<template>
	<div>
		<breadcrumbs />
		<loading :active.sync="isLoading"></loading>

		<div class="content-i">
			<div class="content-box">
				<div class="element-wrapper">
					<div class="invoice-w">
						<div class="infos">
							<div class="info-1">
								<div class="invoice-logo-w">
									<img alt="" src="img/logo2.png">
								</div>
								<div class="company-name">
									{{ receipt.company.name }}
								</div>
								<div class="company-address">
									{{ receipt.company.office }}
								</div>
								<div class="company-extra">
									tel. +{{receipt.company.phone.country_code}} {{receipt.company.phone.national_number}}
								</div>
							</div>
							<div class="info-2">
								<div class="company-name">
									{{ receipt.client.name }}
								</div>
								<div class="company-address">
									{{ receipt.client.homeAddress }}
									<br/>
									{{ receipt.client.region.name }}
								</div>
							</div>
						</div>
						<div class="invoice-heading">
							<h3>
								{{ t.receipt }}
							</h3>
							<div class="invoice-date">
								{{ receipt.createdAt | moment('D MMMM dddd, Y', session.timezone) }}
							</div>
						</div>
						<div class="invoice-body">
							<div class="invoice-desc">
								<div class="desc-label">
									{{ t.receipt }} #
								</div>
								<div class="desc-value">
									{{ receipt.id }}
								</div>
							</div>
							<div class="invoice-table">
								<table class="table">
									<thead>
									<tr>
										<th>
											{{ t.description }}
										</th>
										<th class="text-right">
											{{ t.amount }}
										</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="transaction in receipt.transactions">
										<td>
											{{ transaction.info }}
										</td>
										<td class="text-right">
											{{ transaction.amount| toMoney(transaction.currency) }}
										</td>
									</tr>
									</tbody>
									<tfoot>
									<tr>
										<td>
											{{ t.total }}
										</td>
										<td class="text-right" colspan="2">
											{{ receipt.amount| toMoney(receipt.currency) }}
										</td>
									</tr>
									</tfoot>
								</table>

							</div>
						</div>
						<div class="invoice-footer">
							<div class="invoice-logo">
								<img alt="" src="img/logo.png"><span>{{ receipt.company.name }}</span>
							</div>
							<div class="invoice-info">
								<span>{{ receipt.company.email }}</span>
								<span>+{{receipt.company.phone.country_code}} {{receipt.company.phone.national_number}}</span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: 'receipts',
        data () {
            return {
                session: this.$root.session,
                t: this.$root.t,
                status: 0,
	            isLoading: false,
                receipt: null
            }
        },
	    watch: {
          '$route.params' () {
              this.fetchReceipt()
          }
	    },
	    mounted () {
            this.fetchReceipt()
	    },
	    methods: {
            fetchReceipt () {
                if (!this.isLoading) {
                    this.isLoading = true
                    this.$http.get(api+'api/v1/receipt/detail/'+this.$route.params.id, {params: {noCache: 1}}).then(response => {

                    this.receipt = response.body.result;
                    this.isLoading = false
                    this.status = response.status;
                }, response => {
                        this.isLoading = false
                        this.status = response.status;
                    });
                }
            }
	    }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/accounting/receipt/item.vue